<script setup lang="ts">
import { ModalConfirmation } from '@shared/ui/modals'

import { useModalLessonsDelete } from '../../../model/lessons/modal-lessons-delete.hook'

defineOptions({
  name: 'ModalLessonsDelete',
})

const {
  refIsOpen,
  refIsDeleting,
  refTitle,
  refDetail,
  refButtonTitle,
  confirm,
  close,
} = useModalLessonsDelete()
</script>

<template>
  <ModalConfirmation
    :show="refIsOpen"
    :loading="refIsDeleting"
    :disabled="refIsDeleting"
    mode="delete"
    :title="refTitle"
    :detail="refDetail"
    :button-title="refButtonTitle"
    cancel-title="Cancel"
    @click:confirm="confirm"
    @click:cancel="close"
  />
</template>
